import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import { useEventStream } from './useEventStream';

/** Mounts the app-wide SSE subscription and shows whether updates are live or polled. */
export function LiveIndicator() {
  const { t } = useTranslation();
  const status = useEventStream();
  const live = status === 'open';
  return (
    <span
      className="flex items-center gap-1.5 text-[11px] text-muted-foreground"
      title={live ? t('ops.live.liveHint') : t('ops.live.pollingHint')}
      data-testid="live-indicator"
    >
      <span className={cn('size-2 rounded-full', live ? 'bg-success' : 'bg-warning')} aria-hidden />
      {live ? t('ops.live.live') : t('ops.live.polling')}
    </span>
  );
}
